export default "__VITE_ASSET__CvZfwyn8__"